import React from 'react'

import Script from 'dangerous-html/react'

import './navigation.css'

const Navigation = (props) => {
  return (
    <div className="navigation-container10">
      <nav id="main-nav" className="navigation-container">
        <div className="navigation-wrapper">
          <a href="#">
            <div className="navigation-logo">
              <div className="navigation-logo-icon">
                <svg
                  fill="none"
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="m18 16 4-4-4-4"></path>
                  <path d="m6 8-4 4 4 4"></path>
                  <path d="m14.5 4-5 16"></path>
                </svg>
              </div>
              <span className="section-title">Idensite</span>
            </div>
          </a>
          <div className="navigation-links-desktop">
            <a href="#">
              <div className="navigation-link">
                <span>Home</span>
              </div>
            </a>
            <a href="#proces">
              <div>
                <div className="navigation-link">
                  <span>Proces</span>
                </div>
              </div>
            </a>
            {/*<a href="#voorbeelden">
              <div>
                <div className="navigation-link">
                  <span>Voorbeelden</span>
                </div>
              </div>
            </a>*/}
            <a href="#prijzen">
              <div>
                <div className="navigation-link">
                  <span>Prijzen</span>
                </div>
              </div>
            </a>
            <a href="#contact">
              <div>
                <div className="navigation-link nav-link-cta">
                  <span>Contact</span>
                </div>
              </div>
            </a>
          </div>
          <button
            id="mobile-toggle"
            aria-label="Toggle navigation"
            aria-expanded="false"
            className="navigation-mobile-toggle"
          >
            <svg
              fill="none"
              width="24"
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              stroke="currentColor"
              viewBox="0 0 24 24"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="icon-menu"
            >
              <path d="M4 6h16M4 12h16M4 18h16"></path>
            </svg>
          </button>
        </div>
      </nav>
      <div id="mobile-menu" className="navigation-mobile-overlay">
        <div className="navigation-mobile-header">
          <a href="#">
            <div className="navigation-logo">
              <div className="navigation-logo-icon">
                <svg
                  fill="none"
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="m18 16 4-4-4-4"></path>
                  <path d="m6 8-4 4 4 4"></path>
                  <path d="m14.5 4-5 16"></path>
                </svg>
              </div>
              <span className="section-title">Idensite</span>
            </div>
          </a>
          <button
            id="mobile-close"
            aria-label="Close navigation"
            className="navigation-mobile-close"
          >
            <svg
              fill="none"
              width="24"
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              stroke="currentColor"
              viewBox="0 0 24 24"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M18 6 6 18M6 6l12 12"></path>
            </svg>
          </button>
        </div>
        <div className="navigation-mobile-content">
          <div className="navigation-mobile-links">
            <a href="Homepage">
              <div className="navigation-mobile-link">
                <span>Home</span>
              </div>
            </a>
            <a href="#proces">
              <div>
                <div className="navigation-mobile-link">
                  <span>Proces</span>
                </div>
              </div>
            </a>
            <a href="#voorbeelden">
              <div>
                <div className="navigation-mobile-link">
                  <span>Voorbeelden</span>
                </div>
              </div>
            </a>
            <a href="#prijzen">
              <div>
                <div className="navigation-mobile-link">
                  <span>Prijzen</span>
                </div>
              </div>
            </a>
            <a href="#contact">
              <div>
                <div className="navigation-mobile-link nav-link-cta">
                  <span>Contact</span>
                </div>
              </div>
            </a>
          </div>
          <div className="navigation-mobile-footer">
            <p className="section-content">
              Ready to build your professional presence?
            </p>
            <a href="mailto:contact@idensite.be?subject=">
              <div className="btn btn-outline">
                <span>contact@idensite.be</span>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div className="navigation-container19">
        <div className="navigation-container20">
          <Script
            html={`<style>
@media (prefers-reduced-motion: reduce) {
.navigation-mobile-overlay, .navigation-mobile-link {
  transition: none;
  transform: none;
}
}
</style>`}
          ></Script>
        </div>
      </div>
      <div className="navigation-container21">
        <div className="navigation-container22">
          <Script
            html={`<script defer data-name="navigation-logic">
(function(){
  const mobileToggle = document.getElementById("mobile-toggle")
  const mobileClose = document.getElementById("mobile-close")
  const mobileMenu = document.getElementById("mobile-menu")
  const navLinks = document.querySelectorAll(".navigation-mobile-link")

  const openMenu = () => {
    mobileMenu.classList.add("is-open")
    document.body.style.overflow = "hidden"
    mobileToggle.setAttribute("aria-expanded", "true")
  }

  const closeMenu = () => {
    mobileMenu.classList.remove("is-open")
    document.body.style.overflow = ""
    mobileToggle.setAttribute("aria-expanded", "false")
  }

  mobileToggle.addEventListener("click", openMenu)
  mobileClose.addEventListener("click", closeMenu)

  navLinks.forEach((link) => {
    link.addEventListener("click", closeMenu)
  })

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && mobileMenu.classList.contains("is-open")) {
      closeMenu()
    }
  })

  let lastScroll = 0
  const nav = document.getElementById("main-nav")

  window.addEventListener("scroll", () => {
    const currentScroll = window.pageYOffset

    if (currentScroll <= 0) {
      nav.style.boxShadow = "none"
      return
    }

    if (currentScroll > 0) {
      nav.style.boxShadow = "0 4px 20px color-mix(in srgb, var(--color-on-surface) 5%, transparent)"
    }

    lastScroll = currentScroll
  })
})()
</script>`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

export default Navigation
